import { useRouter } from 'next/router';
import React from 'react';

import ListPageStates from '@/src/shared/components/ListPage/ListPageStates';
import useListSearch from '@/src/shared/hooks/useListSearch';
import states from '@/utils/states';

const searchOptions = {
  pubCode: 418,
  yearsBack: 5,
};

const StateCapitalBulletins = props => {
  const { statecode } = props;
  const router = useRouter();
  const _statecode = statecode || router.query.slug;
  const [loading, results] = useListSearch(searchOptions, _statecode);

  return (
    <ListPageStates
      title="Capital Bulletin"
      heroContent={null}
      results={results}
      truncateResultSummary
      searchOptions={searchOptions}
      statecode={statecode}
      loading={loading}
      routeBase="/advocacy/state/capital-bulletin"
    />
  );
};

export async function getStaticPaths() {
  return {
    paths: states.map(s => ({ params: { slug: s.StateCode } })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  return {
    props: {
      statecode: params.slug || 0,
    },
  };
}

export default StateCapitalBulletins;
